// Component for displaying and managing outfits
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Outfits = () => {
    const [outfits, setOutfits] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [outfitNameSearchTerm, setOutfitNameSearchTerm] = useState('');
    const [occasionSearchTerm, setOccasionSearchTerm] = useState('');
    const [clothesSearchTerm, setClothesSearchTerm] = useState('');
    const [expandedClothes, setExpandedClothes] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        fetchOutfits(); // Fetch outfits data on component load
    }, []);

    const fetchOutfits = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('http://localhost:3000/api/outfits', {
                headers: { Authorization: `Bearer ${token}` }
            });
            console.log(response.data); // Log the data to check its structure
            setOutfits(response.data);
        } catch (error) {
            console.error('Error fetching outfits:', error);
        }
    };

    const handleDelete = async (id) => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`http://localhost:3000/api/outfits/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setOutfits(outfits.filter(outfit => outfit._id !== id));
        } catch (error) {
            console.error('Error deleting outfit:', error);
        }
    };

    const handleToggleCloth = (outfitId, clothId) => {
        setExpandedClothes((prev) => ({
            ...prev,
            [outfitId]: {
                ...prev[outfitId],
                [clothId]: !prev[outfitId]?.[clothId]  // Toggle visibility for the clicked cloth
            }
        }));
    };

    const filteredOutfits = outfits.filter(outfit => {
        // Search by outfit name
        const matchesOutfitName = outfit.outfit_name.toLowerCase().includes(outfitNameSearchTerm.toLowerCase());

        // Search by occasions (array)
        const matchesOccasions = outfit.occasion.some(occ => occ.toLowerCase().includes(occasionSearchTerm.toLowerCase()));

        // Search by clothing items (array of objects)
        const matchesClothingItems = outfit.clothing_items.some(cloth => 
            cloth.cloth_name.toLowerCase().includes(clothesSearchTerm.toLowerCase()) ||
            cloth.color.some(col => col.toLowerCase().includes(clothesSearchTerm.toLowerCase())) || 
            cloth.category.some(cat => cat.toLowerCase().includes(clothesSearchTerm.toLowerCase())) ||
            cloth.season.some(sea => sea.toLowerCase().includes(clothesSearchTerm.toLowerCase()))
        );

        // Combine all conditions
        return matchesOutfitName && matchesOccasions && matchesClothingItems;
    });

    return (
        <div className="outfits-container">
            <h1><strong>𝒪𝓊𝓉𝒻𝒾𝓉𝓈 ({outfits.length})</strong></h1> {/* Outfit count */}
            
            {/* Search Filters Button */}
            <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="dropdown-btn">
                <i className="fa-solid fa-magnifying-glass"></i> <strong>𝒮𝑒𝒶𝓇𝒸𝒽 𝐹𝒾𝓁𝓉𝑒𝓇𝓈</strong>
            </button>

            {/* Create Outfit Button */}
            <button onClick={() => navigate('/create-outfit')} className="create-outfit-btn">
                <i className="fa-solid fa-plus"></i> <strong>𝒞𝓇𝑒𝒶𝓉𝑒 𝒪𝓊𝓉𝒻𝒾𝓉</strong>
            </button>

            {/* Dropdown Search Filters */}
            {isDropdownOpen && (
                <div className="search-container">
                    <div className="filters-container">
                        <label>
                            <strong>Outfit Name:</strong>
                            <input
                                type="text"
                                placeholder="Search by name"
                                value={outfitNameSearchTerm}
                                onChange={(e) => setOutfitNameSearchTerm(e.target.value)}
                            />
                        </label>
                        <label>
                            <strong>Activity\-ies:</strong>
                            <input
                                type="text"
                                placeholder="e.g. Coffee, Gym, Night Out"
                                value={occasionSearchTerm}
                                onChange={(e) => setOccasionSearchTerm(e.target.value)}
                            />
                        </label>
                        <label>
                            <strong>Clothes:</strong>
                            <input
                                type="text"
                                placeholder="Search by cloth name, color, category, or season"
                                value={clothesSearchTerm}
                                onChange={(e) => setClothesSearchTerm(e.target.value)}
                            />
                        </label>
                    </div>
                </div>
            )}

            {/* Display Outfits */}
            <div className="outfits-grid">
                {filteredOutfits.map((outfit) => (
                    <div key={outfit._id} className="outfit-item">
                        <h4><strong>{outfit.outfit_name}</strong></h4>
                        <p><strong>Activity\-ies:</strong> {outfit.occasion.join(', ')}</p>
                        <p><strong>Clothes:</strong></p>
                        <div className="clothing-items">
                            {outfit.clothing_items.map((cloth) => (
                                <div key={cloth._id} className="clothing-item">
                                    <p
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleToggleCloth(outfit._id, cloth._id); // Pass both outfit and cloth ID
                                        }}
                                        className="cloth-name"
                                    >
                                        {cloth.cloth_name}
                                    </p>
                                    {expandedClothes[outfit._id]?.[cloth._id] && (
                                        <img src={cloth.image_url} width="100" alt={cloth.cloth_name} />
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className="outfit-actions">
                            <button className="edit-btn" onClick={() => navigate(`/edit-outfit/${outfit._id}`)}>
                                <i className="fa-solid fa-pencil"></i> <strong>𝐸𝒹𝒾𝓉</strong>
                            </button>
                            <button className="delete-btn" onClick={() => handleDelete(outfit._id)}>
                                <i className="fa-solid fa-trash"></i> <strong>𝒟𝑒𝓁𝑒𝓉𝑒</strong>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Outfits;
